import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSparks32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSparks32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M22.544 3.22a1 1 0 0 0-1 1 3.293 3.293 0 0 1-3.29 3.293h-.003a1 1 0 0 0 0 2h.002a3.293 3.293 0 0 1 3.29 3.293 1 1 0 0 0 2 0 3.293 3.293 0 0 1 3.293-3.293 1 1 0 1 0 0-2 3.293 3.293 0 0 1-3.292-3.293 1 1 0 0 0-1-1m1.196 5.293a5.3 5.3 0 0 1-1.196-1.196c-.332.46-.737.864-1.196 1.196.46.332.864.737 1.196 1.196a5.3 5.3 0 0 1 1.196-1.196m-12.817-.505a1 1 0 0 0-.874.992 5.877 5.877 0 0 1-5.874 5.877h-.004a1 1 0 1 0 0 2h.005a5.877 5.877 0 0 1 5.873 5.877 1 1 0 0 0 1 1h.006a1 1 0 0 0 .994-1 5.877 5.877 0 0 1 5.877-5.877 1 1 0 1 0 0-2A5.877 5.877 0 0 1 12.049 9a1 1 0 0 0-1.126-.992m3.159 7.87a7.9 7.9 0 0 1-3.033-3.034 7.9 7.9 0 0 1-3.034 3.033 7.9 7.9 0 0 1 3.034 3.033 7.9 7.9 0 0 1 3.033-3.033m7.888 2.085a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0 10a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1m4-4a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm-9-1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSparks32);
